"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _eventemitter = _interopRequireDefault(require("eventemitter3"));

/**
 * @file 获取端标识
 * @date 2021-12-07
 */
var EE = new _eventemitter.default();
var _default = EE;
exports.default = _default;